import BaseSlider from '@components/base/BaseSlider';
import Flickity from 'flickity';
import 'flickity-mimic';

export default class Stage {
	private readonly element: HTMLElement;

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		const mediaSlider: HTMLElement | null = this.element.querySelector('.m-stage__media-slider') as HTMLElement;

		mediaSlider.addEventListener(BaseSlider.events.SLIDER_READY, (): void => Stage.mediaSliderReady());
	}

	private static mediaSliderReady(): void {
		const textSlider: Flickity = Flickity.data('.m-stage__text-slider .c-content-slider__slides');
		const target = '.m-stage__media-slider .c-media-slider__slides';
		textSlider.setCompanion(target);

		// workaround against glitch
		window.addEventListener('resize', (): void => {
			setTimeout((): void => {
				textSlider.resize();
			}, 1000);
		});
	}
}
